import React from 'react';

export default function Aboutme() {
  return (
    <div>
      <div className="container-fluid">
        <div className="container-fluid aboutme1" style={{ maxWidth: '1440px' }}>
          <div
            className="row aboutme2"
            id="aboutme"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center', // Align image and text in a row at the top
              maxWidth: '1220px',
            }}
          >
            {/* Image Container */}
            <div
              className="col-lg-5 col-md-6 col-sm-12 aboutme3 mt-2"
              style={{
                border: '4px solid black',
                margin: '0 auto',
                borderRadius: '10px',
                padding: 0,
                display: 'flex',
                // justifyContent: 'center', // Center image box horizontally
                alignItems: 'center', // Center image box vertically
                // height: '500px', // Set a height for the box
              }}
            >
              <img
                src="/images/me 1.png"
                className="aboutme4"
                alt=""
                style={{
                  borderRadius: '17px',
                  // width: '100%',
                  // height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </div>

            {/* Text Container */}
            <div className="col-lg-7 col-md-6 col-sm-12 aboutme5" style={{ gap: '20px' }}>
              <h1
                className="aboutmeh1 sora"
                style={{
                  paddingTop: '16px',
                  paddingBottom: '16px',
                  fontWeight: '400',
                }}
              >
                About <span className="sora" style={{ fontWeight: '800' }}>Me</span>
              </h1>
              <p
                className="sora"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                }}
              >
                I'm a passionate, self-proclaimed designer who specializes in full-stack development (React.js & Node.js). I am very enthusiastic about bringing the technical and visual aspects of digital products to life. User experience, pixel-perfect design, and writing clear, readable, highly performant code matter to me.
              </p>
              <p
                className="sora"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                }}
              >
                I began my journey as a web developer in 2015, and since then, I've continued to grow and evolve as a developer, taking on new challenges and learning the latest technologies along the way. Now, in my early thirties, 7 years after starting my web development journey, I'm building cutting-edge web applications using modern technologies such as Next.js, TypeScript, TailwindCSS, Supabase, and much more.
              </p>
              <p
                className="sora"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                }}
              >
                When I'm not in full-on developer mode, you can find me hovering around on Twitter or on Indie Hacker, witnessing the journey of early startups or enjoying some free time. You can follow me on Twitter where I share tech-related bites and build in public, or you can follow me on GitHub.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
